import { MdPhoneInTalk } from "react-icons/md";

function CallButton() {
  return (
    <a href="tel:+19493289951" className="call-btn" aria-label="Call Us">
        <MdPhoneInTalk className="call-icon"/>
    </a>
  );
};

export default CallButton;